import React from 'react'

import {
    HowItWorksImage,
    HowItWorksItem,
    HowItWorksText,
} from './styled'

import {
    SectionHeader,
    SectionHeaderContainerProps,
} from '../../components/SectionHeader'
import { ImageUrls } from '../../utils/imageUtils'

export interface HowItWorksProps {
    sectionHeaderProps?: SectionHeaderContainerProps
}

export const HowItWorks: React.FC<HowItWorksProps> = ({
    sectionHeaderProps,
    ...props
}) => {
    return (
        <div>
            <SectionHeader
                label="How it Works"
                color={sectionHeaderProps?.color}
                borderColor={sectionHeaderProps?.borderColor}
            />

            <div className="flexDiv showBorder--mobile">
                <HowItWorksItem>
                    <HowItWorksImage src={ImageUrls.star2} alt="Spend $1, earn 2 points. Use points for free pizza & more" />
                    <HowItWorksText>
                        <div>
                            <p>
                                Earn <strong>2 points for every $1</strong> spent on food & drinks.
                            </p>
                            <p>
                                Use your points to get <strong>FREE</strong> breadsticks, pizza and more!
                            </p>
                        </div>
                    </HowItWorksText>
                </HowItWorksItem>
            </div>
        </div>
    )
}
